import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './assets/scss/app.scss'
import { store } from './redux/store'
const rootElem = document.getElementById('root')

if (rootElem) {
	const root = ReactDOM.createRoot(rootElem)
	root.render(
		<BrowserRouter>
			{
				<Provider store={store}>
					<App />
				</Provider>
			}
		</BrowserRouter>
	)
}
